import './style/index.js';

import _Skeleton from './Skeleton';

export type { SkeletonProps } from './Skeleton';
export * from './type';

export const Skeleton = _Skeleton;
export default Skeleton;
